import React, { useState } from "react";

const norm = (s: string) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export interface SSOption {
  value: string;
  label: string;
  sub?: string;
}

/** Sélecteur avec champ de recherche (filtre insensible aux accents et à la casse,
 *  sur n'importe quelle partie du libellé). Même composant que le sélecteur de contrat des tickets. */
export function SearchSelect({
  options,
  value,
  onChange,
  placeholder = "Sélectionner…",
  testId,
  allowEmpty = true,
  emptyLabel = "—",
  disabled = false,
}: {
  options: SSOption[];
  value: string | null;
  onChange: (v: string | null) => void;
  placeholder?: string;
  testId?: string;
  allowEmpty?: boolean;
  emptyLabel?: string;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = options.find((o) => o.value === value);
  const ql = norm(q.trim());
  const filtered = options.filter((o) => !ql || norm(`${o.label} ${o.sub || ""}`).includes(ql)).slice(0, 60);
  return (
    <div className="relative">
      <button
        type="button"
        data-testid={testId}
        disabled={disabled}
        className="nx-input w-full text-left disabled:opacity-60"
        onClick={() => setOpen((o) => !o)}
      >
        {selected ? selected.label : <span className="text-muted">{placeholder}</span>}
      </button>
      {open && !disabled && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-line bg-white shadow-lg">
            <input
              data-testid={testId ? `${testId}-search` : undefined}
              autoFocus
              className="nx-input !rounded-none !border-x-0 !border-t-0"
              placeholder="Rechercher…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <div className="max-h-56 overflow-y-auto">
              {allowEmpty && (
                <button
                  type="button"
                  className="block w-full px-3 py-2 text-left text-sm hover:bg-soft"
                  onClick={() => { onChange(null); setOpen(false); setQ(""); }}
                >
                  {emptyLabel}
                </button>
              )}
              {filtered.map((o) => (
                <button
                  key={o.value}
                  type="button"
                  data-testid={testId ? `${testId}-opt-${o.value}` : undefined}
                  className="block w-full px-3 py-2 text-left text-sm hover:bg-soft"
                  onClick={() => { onChange(o.value); setOpen(false); setQ(""); }}
                >
                  <span className={o.value === value ? "font-semibold text-green" : ""}>{o.label}</span>
                  {o.sub ? <span className="text-muted"> · {o.sub}</span> : null}
                </button>
              ))}
              {filtered.length === 0 && <p className="px-3 py-2 text-xs text-muted">Aucun résultat</p>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export const orgOptions = (orgs: any[]): SSOption[] =>
  (orgs || []).map((o) => ({ value: o.id, label: o.nom, sub: o.ville || o.pays || undefined }));
